export default "__VITE_ASSET__b9357e27__"